const defaultStatusMap = { ok: 'bg-turquoise-bright', notOk: 'bg-vivid-rose' } as const;

export function Status<StatusMap extends Record<string, string>>({
    className = '',
    status,
    statusMap,
}: {
    className?: string;
    status: keyof StatusMap;
    statusMap: StatusMap;
}) {
    return <div className={`size-[14px] rounded-full ${statusMap[status]} ${className}`} />;
}

Status.defaultStatusMap = defaultStatusMap;
